import { Linkedin } from "lucide-react";

const STEPS = [
  ["Open your profile", <>On a computer, go to <span className="font-semibold text-ink">linkedin.com</span> and open your own profile.</>],
  ["Find Save to PDF", <>Click <span className="font-semibold text-ink">Resources</span> (or <span className="font-semibold text-ink">More</span>) under your name, then <span className="font-semibold text-ink">Save to PDF</span>.</>],
  ["Upload it here", <>LinkedIn downloads a PDF of your profile. Upload that file below.</>],
];

export default function LinkedInGuide({ compact = false, uploadWhere = "below" }) {
  const steps = STEPS.map(([t, d], i) => (i === 2 ? [t, <>LinkedIn downloads a PDF of your profile. Upload that file {uploadWhere}.</>] : [t, d]));
  return (
    <div data-testid="linkedin-guide" className={`rounded-xl border border-line bg-canvas ${compact ? "p-3.5" : "p-4 sm:p-5"}`}>
      <div className="flex items-center gap-2 text-sm font-semibold text-ink">
        <Linkedin className="w-4 h-4 text-brand" aria-hidden="true" /> Get your LinkedIn PDF in about 20 seconds
      </div>
      <ol className={`mt-3 grid gap-2.5 ${compact ? "" : "sm:grid-cols-3"}`}>
        {steps.map(([t, d], i) => (
          <li key={t} className="flex gap-2.5">
            <span className="w-6 h-6 rounded-full bg-brand-soft text-brand-text text-xs font-bold flex items-center justify-center shrink-0">{i + 1}</span>
            <span className="text-sm text-body leading-snug"><span className="block font-semibold text-ink">{t}</span>{d}</span>
          </li>
        ))}
      </ol>
      <p className="mt-3 text-xs text-faint">LinkedIn's app can't save a PDF, so use a web browser. We only use facts from your profile and never post anything.</p>
    </div>
  );
}
